import React from "react";

export const Top = ({ x = 0, y = 0 }) => (
  <g style={{ transform: `translate(${x}px, ${y}px)` }}>
    <rect width={44} height={28} rx={1} fill="#F1F2F6" />

    <g fill="#8E97A9">
      <circle cx={4.5} cy={4.5} r={2.5} />
      <circle cx={4.5} cy={10.8} r={2.5} />
      <circle cx={4.5} cy={17.2} r={2.5} />
      <circle cx={4.5} cy={23.5} r={2.5} />
      <g
        stroke="#8E97A9"
        strokeWidth={2}
        strokeLinecap="round"
        strokeMiterlimit={10}
      >
        <line className="st2" x1={10} y1={4.5} x2={41} y2={4.5} />
        <line className="st2" x1={10} y1={10.8} x2={41} y2={10.8} />
        <line className="st2" x1={10} y1={17.2} x2={41} y2={17.2} />
        <line className="st2" x1={10} y1={23.5} x2={41} y2={23.5} />
      </g>
    </g>
  </g>
);
